import {Injectable} from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest, HttpResponse
} from '@angular/common/http';
import {Observable, tap} from 'rxjs';
import {StoreService} from '../shared/services/store.service';
import {MessageService} from 'primeng/api';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private store: StoreService, private messageService: MessageService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && event.body && event.body.message && event.body.message.includes("Store Cloud Request Error")) {
          let lang = localStorage.getItem('lang')
          if (!lang && lang !== '') {
            lang = 'en'
          }
          let message = '';
          if (lang == 'fr') {
            message = 'Service non disponible, veuillez réessayer plus tard.';
          } else {
            message = 'Service not available, please try again later.';
          }
          this.messageService.add({
            severity: 'error',
            summary: message
          });
        }
      })
    );
  }

}

